import React, { useState, FC, useEffect } from "react";
import Container from "../../components/layout/Container/Container"; // Corrected typo "Contaier" to "Container"
import Banner from "../../components/layout/Sections/Banner";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { faCopy, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faSearch, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap';
import { IcountryOptions } from "../../typings/models/CountryOption";
import { valueContainerCSS } from "react-select/dist/declarations/src/components/containers";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { ISampleNameModel } from "../../typings/models/SampleNameModel";
import { ISampleDescriptionModel } from "../../typings/models/SampleDescriptionModel";
import { ISampleLocTypeDistrictModel } from "../../typings/models/SampleLocTypeDistrictModel";
import { ITestCodeMasterModel } from "../../typings/models/TestCodeMasterModel";

interface PersonalInfo {
    customerName: string;
    mobileNumber: string;
    email: string;
    address: string;
    nric: string;
    homeNumber: string;
    paymentMethod: string;
}

const initialPersonalInfo: PersonalInfo = {
    customerName: 'Sowmya',
    mobileNumber: '+65 98765678',
    email: 'jeremy.ten@gmail.com',
    address: '30 Sembawang Drive Sun Plaza Singapore 757713',
    nric: '5671',
    homeNumber: '+65 98765678',
    paymentMethod: 'Giro'
};

export interface SampleDatas {
    id: number;
    sampleMarking: string;
    sampleType: string;
    sampleName: string;
    sampleDesc: string;
    samplingDate: Date;
    sampleLocation: string;
    country: string;
    district: string;
    signsSymptoms: string;
    diseaseDistribution: string;
    severity: string;
    gpsCoordinate: string;
}
interface SampleData {
    id: number;
    sampleMarking: string;
    sampleType: string;
    sampleName: string;
    sampleDesc: string;
    samplingDate: string;
    sampleLocation: string;
    country: string;
    district: string;
    signsSymptoms: string;
    diseaseDistribution: string;
    severity: string;
    gpsCoordinate: string;
    aliveDead?: string;
    species?: string;
    breed?: string;
    specimenDescription?: string;
    numberOfSamples?: string;
    forBacterialCultureOnly: boolean;
    antibioticSensitivityTestRequired: boolean;
    sampledBy: string;
    samplingDateFrom: string;
    samplingDateTo: string;
}

const AnimalPurposeCode = () => {

    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    const state = location.state as { personalInfo: PersonalInfo; selectedType: string };
    const currentStep = location.state?.currentStep || 2;
    const handleShowModal = () => setShowModal(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [personalInfo, setPersonalInfo] = useState<PersonalInfo>(state?.personalInfo || initialPersonalInfo);
    const [typeOfServices, setTypeOfServices] = useState<string>('');
    const [typeOfApplication, setTypeOfApplication] = useState<string>('');
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('sampleDetails'); // New state for active tab
    const [currentSampleId, setCurrentSampleId] = useState<number | null>(null);
    const [showSearchTestsModal, setShowSearchTestsModal] = useState(false);
    const handleShowSearchTestsModal = () => setShowSearchTestsModal(true);
    const handleCloseSearchTestsModal = () => setShowSearchTestsModal(false);
    const [showDistrictSearchModal, setShowDistrictSearchModal] = useState(false);
    const handleShowDistrictSearchModal = () => setShowDistrictSearchModal(true);
    const handleCloseDistrictSearchModal = () => setShowDistrictSearchModal(false);


    const [sampleMarking, setSampleMarking] = useState('');
    const [sampleType, setSampleType] = useState('');
    const [sampleName, setSampleName] = useState('');
    const [sampleDescription, setSampleDescription] = useState('');
    const [samplingDate, setSamplingDate] = useState('');
    const [sampleLocation, setSampleLocation] = useState('');
    const [country, setCountry] = useState('');
    const [district, setDistrict] = useState('');
    const [signsSymptoms, setSignsSymptoms] = useState('');
    const [diseaseDistribution, setDiseaseDistribution] = useState('');
    const [severity, setSeverity] = useState('');
    const [gpsCoordinate, setGpsCoordinate] = useState('');
    const [forBacterialCultureOnly, setForBacterialCultureOnly] = useState(false);
    const [antibioticSensitivityTestRequired, setAntibioticSensitivityTestRequired] = useState(false);
    const [sampledBy, setSampledBy] = useState('');
    const [samplingDateFrom, setSamplingDateFrom] = useState('');
    const [samplingDateTo, setSamplingDateTo] = useState('');


    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const maxdate = currentDate.toISOString().split("T")[0];
    const minDate = "1990-01-01";


    const [showDiseaseSignDetails, setShowDiseaseSignDetails] = useState(false);

    const toggleDiseaseSignDetails = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setShowDiseaseSignDetails(!showDiseaseSignDetails);
    };

    const handlePersonalInfoChange = (key: keyof PersonalInfo, value: string) => {
        setPersonalInfo({ ...personalInfo, [key]: value });
    };
    const initialSamples: SampleData[] = [
        {
            id: Date.now(),
            sampleMarking: sampleMarking,
            sampleType: sampleType,
            sampleName: sampleName,
            sampleDesc: sampleDescription,
            samplingDate: samplingDate,
            sampleLocation: sampleLocation,
            country: country,
            district: district,
            signsSymptoms: signsSymptoms,
            diseaseDistribution: diseaseDistribution,
            severity: severity,
            gpsCoordinate: gpsCoordinate,
            aliveDead: '',
            species: '',
            breed: '',
            numberOfSamples: '',
            forBacterialCultureOnly: false,
            antibioticSensitivityTestRequired: false,
            sampledBy: '',
            samplingDateFrom: '',
            samplingDateTo: '',
        },
    ];

    const [samples, setSamples] = useState<SampleData[]>([...initialSamples]);

    const handleSpecimenDetailsClick = () => setActiveTab('sampleDetails');
    const handleSamplesTestsClick = () => setActiveTab('samplesTests');

    const handleAliveDeadChange = (e: React.ChangeEvent<HTMLSelectElement>, sampleId: number) => {
        const newStatus = e.target.value;
    };

    const handleSpeciesBreedChange = (e: React.ChangeEvent<HTMLSelectElement>, sampleId: number) => {
        const newSpeciesBreed = e.target.value;
    };
    const handlePreviousClick = () => {
        navigate('/choose-application');
    };

    const handleSampleMarkingChange = (event: React.ChangeEvent<HTMLInputElement>, sampleId: number) => {
        const newSampleMarking = event.target.value;
        setSamples(samples => samples.map(sample => {
            if (sample.id === sampleId) {
                return { ...sample, sampleMarking: newSampleMarking };
            }
            return sample;
        }));
    };


    const handleNumberOfSamplesChange = (e: React.ChangeEvent<HTMLInputElement>, sampleId: number) => {
        const newNumberOfSamples = e.target.value; // Keep it as a string
      
        setSamples(currentSamples =>
          currentSamples.map(sample => {
            if (sample.id === sampleId) {
              return { ...sample, numberOfSamples: newNumberOfSamples };
            }
            return sample;
          })
        );
      };
      

    const handleSampleChange = (sampleId: number, key: keyof SampleData, value: any) => {
        setSamples(samples => samples.map(sample => {
            if (sample.id === sampleId) {
                return { ...sample, [key]: value };
            }
            return sample;
        }));
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>, sampleId: number) => {
        const newDateValue = event.target.value;
        setSamplingDate(newDateValue);
        // Proceed only if newDateValue is not an empty string
        if (newDateValue) {
            const newDate = new Date(newDateValue + 'T00:00:00'); // Create a Date object

            // Check if the newDate is valid and within the allowed range
            if (!isNaN(newDate.getTime())) {
                const maxDateObj = new Date(maxdate + 'T23:59:59');

                if (newDate <= maxDateObj) {
                    handleSampleChange(sampleId, 'samplingDate', newDate);
                }
            }
        } else {
            // If the input is cleared, update the state to null or an empty string

            handleSampleChange(sampleId, 'samplingDate', null);
        }
    };

    const handleSignSympChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSignsSymptoms(event.target.value);
    };

    const handleDiseaseChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setDiseaseDistribution(event.target.value);
    };

    const handleSeverityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSeverity(event.target.value);
    };

    const handleGPSChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGpsCoordinate(event.target.value);
    };

    const handleNextClick = () => {
    
        setSamples(initialSamples);
        navigate('/project-details', {
            state: {
                personalInfo: personalInfo,
                samples: initialSamples,
                typeOfServices: typeOfServices,
                typeOfApplication: typeOfApplication,
            }
        });
    };

    const handleCopySample = (sampleId: number) => {
        setSamples(prevSamples => {
            const sampleToCopy = prevSamples.find(s => s.id === sampleId);
            if (sampleToCopy) {
                const newSample = { ...sampleToCopy, id: Date.now() };
                return [...prevSamples, newSample];
            }
            return prevSamples;
        });
    };

    const handleDeleteSample = (sampleId: number) => {
        setSamples(samples => samples.filter(sample => sample.id !== sampleId));
    };

    const handleSampleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSampleType(event.target.value);

    };

    const handleSampleNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedName = event.target.value;
        setSampleName(selectedName);

    };
    const handleSampleDescChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedDescription = event.target.value;
        setSampleDescription(selectedDescription);

    };

    // const handleRemoveTest = (labID: number | undefined) => {
    //     setTestsToDisplay(currentTests => currentTests.filter(test => test.labID !== labID));
    // };


    const sampleLocationMapping: { [key: string]: string } = {
        '1': 'Local',
        '2': 'Foreign',

    };


 


    let bannerName = "Application for Laboratory Testing";


    return (
        <>
            <Header />
            <Container>
                {/* <h1>{bannerName}</h1> */}
                <div className="h1Lab">{bannerName} </div>
                <div className="stepwizard">
                    <div className="stepwizard-row setup-panel row">
                        <div className={`stepwizard-step col-2 ${currentStep >= 1 ? 'completed' : ''}`}>
                            <a type="button" className={`btn btn-border ${currentStep >= 1 ? 'btn-success' : ''}`}>
                                {currentStep > 1 ? <i className="fa fa-check" aria-hidden="true"></i> : <p>1</p>}
                            </a>
                            <p>Choose Application</p>
                        </div>
                        <div className={`stepwizard-step col-2 ${currentStep === 2 ? 'current-active' : ''}`}>
                            <a data-id="#step-2" type="button" className="btn btn-border">
                                <span className="step-circle"><p>2</p></span>
                            </a>
                            <p>Samples Details</p>
                        </div>
                        <div className="stepwizard-step col-2 ">
                            <a data-id="#step-3" type="button" className="btn btn-border disabled"
                            >
                                <span className="step-circle"><p>3</p></span></a>
                            <p>Project Details
                            </p>
                        </div>
                        <div className="stepwizard-step col-2">
                            <a data-id="#step-4" type="button" className="btn btn-border disabled"
                            >
                                <span className="step-circle"><p>4</p></span></a>
                            <p>Cost & Confirm</p>
                        </div>
                    </div>
                </div>
                <div className="row setup-content" id="step-1" >
                    <div className="col-md-12">
                        <div className="tab-wizard-content">
                            <div className="personal-info">
                                <div className="info-heading">
                                    <a href="#" className="edit-icon float-end" onClick={handleShowModal}><i className="fa fa-pencil-square-o"></i> Edit</a>
                                    {/* <button className="edit-icon float-end" onClick={toggleEditMode}>
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </button> */}

                                    <h2>Personal Information</h2>
                                </div>

                                <div className="info-content">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Customer Name</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.customerName}
                                                            onChange={(e) => handlePersonalInfoChange('customerName', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.customerName}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Mobile Number</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.mobileNumber}
                                                            onChange={(e) => handlePersonalInfoChange('mobileNumber', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.mobileNumber}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Email</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.email}
                                                            onChange={(e) => handlePersonalInfoChange('email', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.email}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Address</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.address}
                                                            onChange={(e) => handlePersonalInfoChange('address', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.address}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Customer NRIC</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.nric}
                                                            onChange={(e) => handlePersonalInfoChange('nric', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.nric}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Office/Home Number</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.homeNumber}
                                                            onChange={(e) => handlePersonalInfoChange('homeNumber', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.homeNumber}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <h6>Made of Payment</h6>
                                                </div>
                                                <div className="col-md-8">
                                                    {isEditMode ? (
                                                        <input
                                                            type="text"
                                                            value={personalInfo.paymentMethod}
                                                            onChange={(e) => handlePersonalInfoChange('paymentMethod', e.target.value)}
                                                        />
                                                    ) : (
                                                        <p><small>:</small> {personalInfo.paymentMethod}</p>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="tab-menu btn-group" role="group" aria-label="Sample details and tests">
                                <button
                                    type="button"
                                    className={`btn ${activeTab === 'sampleDetails' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={handleSpecimenDetailsClick}
                                >
                                    Sample Details
                                </button>
                                <button
                                    type="button"
                                    className={`btn ${activeTab === 'samplesTests' ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={handleSamplesTestsClick}
                                >
                                    Samples & Tests
                                </button>
                            </div>


                            <div className="info-content">
                                {activeTab === 'sampleDetails' && (
                                    <form>
                                        <div className="form-group">
                                            <label htmlFor="purposeOfTest">Purpose of Test</label>
                                            <select id="purposeOfTest" className="form-control">
                                                <option value=""></option>
                                                <option value="1">Disease Diagnosis</option>
                                                <option value="2">Export</option>
                                                <option value="3">Import</option>
                                                <option value="4">Others</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="purposeOfTest">Country Of Birth</label>
                                            <select id="purposeOfTest" className="form-control">
                                                {/* Populate options */}
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label d-block">Clinical History & Disease Signs</label>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="healthy" name="clinicalHistory" value="Healthy" />
                                                <label className="form-check-label" htmlFor="healthy">Healthy</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" id="diseased" name="clinicalHistory" value="Diseased" />
                                                <label className="form-check-label" htmlFor="diseased">Diseased</label>
                                            </div>
                                            <a href="#diseaseSignDetails" className="link-primary" onClick={toggleDiseaseSignDetails}>Disease Sign: [...]</a>
                                        </div>

                                        {showDiseaseSignDetails && (
                                            <div id="diseaseSignDetails" className="mt-3">
                                                <div className="mb-3">
                                                    <label htmlFor="diseasePattern" className="form-label">Disease Pattern</label>
                                                    <select id="diseasePattern" className="form-select">
                                                        <option value=""></option>
                                                        <option value="1">Increasing Mortality</option>
                                                        <option value="2">Low Grade Mortality</option>
                                                        <option value="2">Only Clinical Signs, No Mortality</option>
                                                        <option value="2">Sudden Deaths</option>
                                                    </select>
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="totalNumberOnPremises" className="form-label">Total No. on Premises</label>
                                                    <input type="text" id="totalNumberOnPremises" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="noDeadOnly" className="form-label">No. Dead Only</label>
                                                    <input type="text" id="noDeadOnly" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="farmArea" className="form-label">Farm Area</label>
                                                    <input type="text" id="farmArea" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="totalNoDead" className="form-label">Total No. Dead</label>
                                                    <input type="text" id="totalNoDead" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="diseasedDeadPercentage" className="form-label">No. or % Diseased Dead</label>
                                                    <div className="row gx-2">
                                                        <div className="col">
                                                            <input type="text" id="diseasedDeadPercentage" className="form-control" />
                                                        </div>
                                                        <div className="col">
                                                            <select id="diseasedDeadUnit" className="form-select">
                                                                <option value=""></option>
                                                                <option value="%">%</option>

                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="totalNumberOfUnits" className="form-label">Total No. of Units</label>
                                                    <div className="row gx-2">
                                                        <div className="col">
                                                            <input type="text" id="totalNumberOfUnits" className="form-control" />
                                                        </div>
                                                        <div className="col">
                                                            <select id="unitType" className="form-select">
                                                                <option value=""></option>
                                                                <option value="nets">Nets</option>
                                                                <option value="ponds">Ponds</option>
                                                                <option value="tanks">Tanks</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="unitSize" className="form-label">Unit Size</label>
                                                    <div className="row gx-2">
                                                        <div className="col">
                                                            <input type="text" id="unitSize" className="form-control" />
                                                        </div>
                                                        <div className="col">
                                                            <select id="unitSizeMetric" className="form-select">
                                                                <option value=""></option>
                                                                <option value="cm">cm</option>
                                                                <option value="feet">feet</option>
                                                                <option value="m">m</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="noAffected" className="form-label">No. Affected</label>
                                                    <input type="text" id="noAffected" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="ageAffected" className="form-label">Age Affected</label>
                                                    <div className="row gx-2">
                                                        <div className="col">
                                                            <input type="text" id="ageAffected" className="form-control" />
                                                        </div>
                                                        <div className="col">
                                                            <select id="ageAffectedUnit" className="form-select">
                                                                <option value=""></option>
                                                                <option value="days">days</option>
                                                                <option value="months">months</option>
                                                                <option value="weeks">weeks</option>
                                                                <option value="years">years</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="mb-3">
                                                    <label htmlFor="sizeAffected" className="form-label">Size Affected</label>
                                                    <input type="text" id="sizeAffected" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="otherSpeciesBreedAffected" className="form-label">Other Species/Breed Affected</label>
                                                    <input type="text" id="otherSpeciesBreedAffected" className="form-control" />
                                                </div>

                                                <div className="mb-3">
                                                    <label htmlFor="clinicalSignsRemarks" className="form-label">Clinical Signs & Remarks</label>
                                                    <textarea id="clinicalSignsRemarks" className="form-control" rows={3}></textarea>
                                                </div>


                                            </div>
                                        )}
                                    </form>
                                )}
                                {activeTab === 'samplesTests' && (
                                    <form>
                                        {samples.map((sample, index) => (
                                            <div className="personal-info" key={sample.id}>
                                                <div className="clonable-block" data-toggle="cloner">
                                                    <div className="clonable" data-clone-number="1">
                                                        <div className="info-heading">
                                                            <ul className="card-icons float-end">
                                                                <li>
                                                                    <button className="icon-button" title="Copy" onClick={() => handleCopySample(sample.id)}>
                                                                        <FontAwesomeIcon icon={faCopy} />
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button className="icon-button" onClick={() => handleDeleteSample(sample.id)}>
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                            <h2>{`Sample ${index + 1}`}</h2>
                                                        </div>
                                                        <div className="info-content">
                                                            <div className="table-responsive mt-2 mb-2">
                                                                <table className="table table-striped product_table start_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Sample Marking <span className="star-red">*</span></th>
                                                                            <th>Alive / Dead<span className="star-red">*</span></th>
                                                                            <th>Species<span className="star-red">*</span></th>
                                                                            <th>Breed<span className="star-red">*</span></th>
                                                                            <th>SpecimenDescription<span className="star-red">*</span></th>
                                                                            <th>No. of Samples<span className="star-red">*</span></th>
                                                                            <th>Test(s)<span className="star-red">*</span></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    aria-label="Sample Marking"
                                                                                    id={`sampleMarking${index}`}
                                                                                    value={sample.sampleMarking}
                                                                                    onChange={(e) => handleSampleMarkingChange(e, sample.id)}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <select className="form-select"
                                                                                    id={`aliveDeadStatus${index}`}
                                                                                    value={sample.aliveDead}
                                                                                    onChange={(e) => handleAliveDeadChange(e, sample.id)}>
                                                                                    <option value=""></option>
                                                                                    <option value="alive">Alive</option>
                                                                                    <option value="dead">Dead</option>
                                                                                </select>
                                                                            </td>
                                                                            <td>
                                                                                <select className="form-select"
                                                                                    id={`species${index}`}
                                                                                    value={sample.species}
                                                                                    onChange={(e) => handleSampleChange(sample.id, 'species', e.target.value)}>
                                                                                    <option value=""></option>
                                                                                </select>
                                                                            </td>
                                                                            <td>
                                                                                <select className="form-select"
                                                                                    id={`breed${index}`}
                                                                                    value={sample.breed}
                                                                                    onChange={(e) => handleSampleChange(sample.id, 'breed', e.target.value)}>
                                                                                    <option value=""></option>
                                                                                    {/* Populate breed options here */}
                                                                                </select>
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    id={`specimenDescription${index}`}
                                                                                    value={sample.specimenDescription}
                                                                                    onChange={(e) => handleSampleChange(sample.id, 'specimenDescription', e.target.value)}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control"
                                                                                    id={`numberOfSamples${index}`}
                                                                                    value={sample.numberOfSamples}
                                                                                    onChange={(e) => handleNumberOfSamplesChange(e, sample.id)}
                                                                                />
                                                                            </td>
                                                                            <button className="btn btn-outline-success w-100" type="button" onClick={() => {
                                                                                setCurrentSampleId(sample.id);
                                                                                handleShowSearchTestsModal();
                                                                            }}>Search Test</button>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        <div className="additional-info">
                                            <div className="checkbox-group">
                                                <input
                                                    type="checkbox"
                                                    id="forBacterialCultureOnly"
                                                    checked={forBacterialCultureOnly}
                                                    onChange={(e) => setForBacterialCultureOnly(e.target.checked)}
                                                />
                                                <label htmlFor="forBacterialCultureOnly">For Bacterial Culture Only</label>
                                            </div>

                                            <div className="checkbox-group">
                                                <input
                                                    type="checkbox"
                                                    id="antibioticSensitivityTestRequired"
                                                    checked={antibioticSensitivityTestRequired}
                                                    onChange={(e) => setAntibioticSensitivityTestRequired(e.target.checked)}
                                                />
                                                <label htmlFor="antibioticSensitivityTestRequired">Antibiotic Sensitivity Test Required</label>
                                            </div>
                                        </div>

                                        <div className="sampled-by">
                                            <label htmlFor="sampledBy">Sampled By</label>
                                            <input
                                                type="text"
                                                id="sampledBy"
                                                value={sampledBy}
                                                onChange={(e) => setSampledBy(e.target.value)}
                                                placeholder="Enter sampler's name"
                                            />
                                        </div>

                                        <div className="sampling-date">
                                            <label htmlFor="samplingDateFrom">Sampling Date From</label>
                                            <input
                                                type="date"
                                                id="samplingDateFrom"
                                                value={samplingDateFrom}
                                                onChange={(e) => setSamplingDateFrom(e.target.value)}
                                            />
                                            <label htmlFor="samplingDateTo">Sampling Date To</label>
                                            <input
                                                type="date"
                                                id="samplingDateTo"
                                                value={samplingDateTo}
                                                onChange={(e) => setSamplingDateTo(e.target.value)}
                                            />
                                        </div>
                                    </form>
                                )}



                                <div className="text-end mt-3 mb-3">
                                    <button className="btn btn-secondary px-4" onClick={handlePreviousClick}>Previous</button>
                                    <button className="btn btn-secondry  px-4">Save Draft</button>
                                    <button className="btn btn-primary nextBtn" type="button" onClick={handleNextClick}>Next</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Container>
            <Footer />
        </>
    );
};

export default AnimalPurposeCode;